import { render, staticRenderFns } from "./weaknessCal.vue?vue&type=template&id=5e986d56"
import script from "./weaknessCal.vue?vue&type=script&lang=js"
export * from "./weaknessCal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports